import React from 'react';
import { DatePicker } from 'rsuite';
import { DateTimeFormatter } from '../formatters';

const DateTimePicker = ({
  value,
  onChange,
  placeholder = 'Select date & time',
  disabled = false,
  minDate = new Date(),
  name = '',
  position,
  maxDays,
  isRequired,
  label,
  errormsg,
}) => {
  const formatDateTimeLocal = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    const hours = `${date.getHours()}`.padStart(2, '0');
    const minutes = `${date.getMinutes()}`.padStart(2, '0');
    const seconds = `${date.getSeconds()}`.padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  const handleChange = (date) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: date ? formatDateTimeLocal(date) : null,
        },
      });
    }
  };

  const shouldDisableDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    if (maxDays !== undefined) {
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + maxDays);
      maxDate.setHours(0, 0, 0, 0);

      return checkDate < today || checkDate > maxDate;
    }

    // Default: only disable past dates
    return checkDate < today;
  };

  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <div className="selectWd">
        {disabled ? (
          <div className="textarea">{value ? DateTimeFormatter(value) : '--'}</div>
        ) : (
          <DatePicker
            placement={position}
            format="MM/dd/yyyy HH:mm"
            value={value ? new Date(value) : null}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            showMeridian={false}
            shouldDisableDate={shouldDisableDate}
            ranges={[]}
            style={{ width: '100%' }}
          />
        )}

        {errormsg && <div className="error-message">{errormsg}</div>}
      </div>
    </>
  );
};

export default DateTimePicker;
